module.exports = __webpack_public_path__ + "img/editInsertShape.87693d49.svg";